import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges, OnInit,
  Output,
} from '@angular/core';
import { LeadComposerChangesModel, LeadsDataAction, LeadsHistory } from "../../../../models/leads/leads.model";
import { ComposerOfferOrOrder } from "../../../../models/action.model";
import { ACTION_DATA_SERVICE, ActionDataService } from "../../../../services/action/data.service";
import { TranslationDirective } from '../../../shared-module/directives/translation.directive';

@Component({
  selector: 'fi-order-offer',
  templateUrl: './order-offer.component.html',
  styleUrls: ['./order-offer.component.scss'],
  standalone: false,
})
export class OrderOfferComponent implements OnChanges, OnInit {
  @Input() isActive: boolean;
  @Input() isMobile = false;
  @Input() isClosed = false;
  @Input() leadId: number;
  @Input() composerOffers: LeadComposerChangesModel[] = [];
  @Input() selectedLeadHistory: LeadsHistory[];
  @Input() composerOrders: LeadComposerChangesModel[] = [];
  @Output() overlayClosed = new EventEmitter<boolean>();
  @Output() loadComposerOffers = new EventEmitter<{data: ComposerOfferOrOrder; placeOrder: boolean}>();
  orderPlaced = false;
  showSaveAndPlaceButton = false;
  editedItem: { isOrder: boolean, leadId: number, data?: LeadComposerChangesModel } = null;
  selectedItem: LeadComposerChangesModel;
  @Input() onAction?: ( name: string, label: string, successCallback?: () => void ) => any;
  @Input() actions?: LeadsDataAction[];

  orderActionName = '';
  offerActionName = '';
  mainOffers: LeadComposerChangesModel[] = [];
  mainOfferIds: number[] = [];
  mainOfferCount = 0;
  hasAlternativeOffers = false;
  offerSubmitExpiredById: {[offerId: number]: boolean} = {};
  offerMenuState = {
    canChangeAlternativeWithMainOffer: false,
    canAddAlternativeToMainOffer: false,
    canMakeOfferToAlternative: false,
  };

  constructor(
    @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService,
  ) {}

  @HostListener('document:click', ['$event'])
  onClick( ev: MouseEvent ): void {
    if ( ev.target instanceof HTMLElement && ev.target.closest('.menu,.menu-btn') ) {
      return;
    }

    this.clearSelectedItem();

    if ( ev.target instanceof HTMLElement && ev.target.closest('a') ) {
      const link = ev.target.closest('a');
      const url = new URL(link.href);
      const label = link.textContent.replace(/[^\p{L}\s]/gmu, '').trim();
      const actionName = url.hash.replace('#', '');

      if ( !url.hostname || url.hostname === document.location.hostname ) {
        ev.preventDefault();
        this.onAction?.(
          actionName,
          label,
          () => {
            if ( actionName === this.orderActionName ) {
              this.orderActionName = '';
            } else {
              this.offerActionName = '';
            }
          }
        );
      }
    }
  }

  ngOnInit(): void {
    if ( this.actions?.length ) {
      const el = document.createElement('div');

      el.innerHTML = TranslationDirective.data?.REQUEST_DETAIL_HEADER_MENU_OFFERS_INFO_TEXT_DESCRIPTION;
      const offerLink = el.querySelector('a')?.href;
      el.innerHTML = TranslationDirective.data?.REQUEST_DETAIL_HEADER_MENU_ORDERS_INFO_TEXT_DESCRIPTION;
      const orderLink = el.querySelector('a')?.href;

      try {
        const actionName = new URL(offerLink).hash.replace('#', '');
        if ( this.actions.some(x => x.Name === actionName) ) {
          this.offerActionName = actionName;
        }
      } catch ( e ) {

      }

      try {
        const actionName = new URL(orderLink).hash.replace('#', '');
        if ( this.actions.some(x => x.Name === actionName) ) {
          this.orderActionName = actionName;
        }
      } catch ( e ) {

      }
      const suggestedAction = this.actions.find((action) => action.Suggested);
      if (suggestedAction && suggestedAction.Name === this.orderActionName ) {
        this.showSaveAndPlaceButton = true;
      }

    }
  }

  ngOnChanges(): void {
    this.updateMainOfferState();
  }

  createOrderOrOffer( offerOrOrder: string ): void {
    if ( !this.editedItem?.data && this.editedItem?.isOrder === (offerOrOrder === 'order') ) {
      this.editedItem = null;
    } else {
      this.editedItem = { isOrder: offerOrOrder === 'order', leadId: this.leadId };
    }
  }

  changeAlternativeWithMainOffer( composerOffer: LeadComposerChangesModel ): void {
    this.actionDataService
      .composerOfferSetToMain(this.leadId, composerOffer.Id)
      .subscribe(( { success, data } ) => {
        this.clearSelectedItem();

        if ( success ) {
          this.composerOffers.forEach(offer => offer.IsMain = false);
          composerOffer.IsMain = true;
          this.updateMainOfferState();
          this.loadComposerOffers.emit({data: composerOffer as any, placeOrder: false});
        }
      });
  }

  addAlternativeToMainOffer( composerOffer: LeadComposerChangesModel ): void {
    this.setMainComposerOffers([...new Set([...this.mainOfferIds, composerOffer.Id])], composerOffer);
  }

  makeOfferToAlternative( composerOffer: LeadComposerChangesModel ): void {
    this.setMainComposerOffers(this.mainOfferIds.filter(id => id !== composerOffer.Id), composerOffer);
  }

  makeMain( composerOffer: LeadComposerChangesModel ): void {
    this.changeAlternativeWithMainOffer(composerOffer);
  }

  setMainComposerOffers( offerIds: number[], changedOffer: LeadComposerChangesModel ): void {
    this.actionDataService
      .composerMultiOffersSetToMain(this.leadId, offerIds)
      .subscribe(( { success, data } ) => {
        this.clearSelectedItem();

        if ( success ) {
          this.composerOffers.forEach(offer => offer.IsMain = offerIds.includes(offer.Id));
          this.updateMainOfferState();
          this.loadComposerOffers.emit({data: changedOffer as any, placeOrder: false});
        }
      });
  }

  updateMainOfferState(): void {
    this.mainOffers = this.composerOffers?.filter(offer => offer.IsMain) ?? [];
    this.mainOfferIds = this.mainOffers.map(offer => offer.Id);
    this.mainOfferCount = this.mainOffers.length;
    this.hasAlternativeOffers = this.composerOffers?.some(offer => !offer.IsMain) ?? false;
    this.updateOfferSubmitExpiredState();
    this.updateOfferMenuState();
  }

  toggleSelectedItem( composerOffer: LeadComposerChangesModel ): void {
    this.selectedItem = this.selectedItem === composerOffer ? null : composerOffer;
    this.updateOfferMenuState();
  }

  clearSelectedItem(): void {
    this.selectedItem = null;
    this.updateOfferMenuState();
  }

  updateOfferMenuState(): void {
    const selectedOffer = this.selectedItem && !this.selectedItem.IsOrder ? this.selectedItem : null;

    this.offerMenuState = {
      canChangeAlternativeWithMainOffer: !!selectedOffer && !selectedOffer.IsMain && this.mainOfferCount === 1,
      canAddAlternativeToMainOffer: !!selectedOffer && !selectedOffer.IsMain,
      canMakeOfferToAlternative: !!selectedOffer && selectedOffer.IsMain && this.mainOfferCount > 1,
    };
  }

  updateOfferSubmitExpiredState(): void {
    const submittedOfferNames = new Set<string>();

    this.selectedLeadHistory?.forEach(item => {
      item.ComposerChanges?.forEach(changes => submittedOfferNames.add(changes.Name));
    });

    this.offerSubmitExpiredById = (this.composerOffers ?? []).reduce<{[offerId: number]: boolean}>((state, offer) => ({
      ...state,
      [offer.Id]: offer.IsHandedOver && submittedOfferNames.has(offer.Name),
    }), {});
  }

  onDelete( composerOffer: LeadComposerChangesModel ): void {
    this.actionDataService.deleteComposerOfferOrder(this.leadId, composerOffer.Id)
      .subscribe(( { success, data } ) => {
        if ( success ) {
          this.clearSelectedItem();
          this.loadComposerOffers.emit({data: {} as any, placeOrder: false});
        }
      });
  }

  editOrderOrOffer( composerOffer: LeadComposerChangesModel, offerOrOrder: string ): void {

    this.clearSelectedItem();

    if ( this.editedItem?.isOrder === (offerOrOrder === 'order') && this.editedItem?.data === composerOffer ) {
      this.editedItem = null;
    } else {
      this.editedItem = { isOrder: offerOrOrder === 'order', leadId: this.leadId, data: composerOffer };
    }
  }

  onEditFinish( value: ComposerOfferOrOrder ): void {
    this.editedItem = null;
    this.loadComposerOffers.emit({data: value, placeOrder: false});
  }

  onEditWithPlaceOrderFinish( value: ComposerOfferOrOrder ): void {
    this.editedItem = null;
    this.orderPlaced = true;
    this.showSaveAndPlaceButton = false;
    this.loadComposerOffers.emit({data: value, placeOrder: true});
  }
}
